export default __webpack_public_path__ + "static/Scroll-Image---Inground-Pool-Removal-9f913d60137ded2fe1fff139c0a7bbd7.jpg";